import {
    POS_DASHBOARD_GO_BUTTON_ACTION,
    POS_DASHBOARD_GO_BUTTON_SUCCESS,
    POS_DASHBOARD_API_ERROR_ACTION,
  } from "./actionType";
  
  const INIT_STATE = {
    PosDashboard_Gobtn: [],
    goBtnLoading: false,
  };
  
  const PosDashboardReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
      case POS_DASHBOARD_GO_BUTTON_ACTION:
        return {
          ...state,
          goBtnLoading: action.config.btnId,
        };
  
      case POS_DASHBOARD_GO_BUTTON_SUCCESS:
        return {
          ...state,
          PosDashboard_Gobtn: action.payload,
          goBtnLoading: false,
        };
  
      case POS_DASHBOARD_API_ERROR_ACTION:
        return {
          ...state,
          goBtnLoading: false,
        };
  
      default:
        return state;
    }
  };
  
  export default PosDashboardReducer;
  